import React from 'react'
import { AppBar, Toolbar, CssBaseline } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { grey } from '@mui/material/colors'
import Logo from '../static/epesiLogoWhite.png'
import NotificationMessage from './NotificationMessage'
import Footer from './Footer'

const useStyles = makeStyles(theme => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: grey[50],
  },
  logo: {
    maxWidth: 160,
  },
  appBar: {
    borderBottom: '0.1px solid #F7FBFE',
    backgroundColor: theme.palette.primary.main,
    [`${theme.breakpoints.between('md', 'md')} and (orientation: landscape)`]: {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.primary.main,
    },
  },
}))

const HomeLayout = ({ children }) => {
  const classes = useStyles()

  return (
    <>
      <CssBaseline />
      <NotificationMessage />
     
      {children}
      <Footer />
    </>
  )
}

export default HomeLayout
